module.exports = __webpack_public_path__ + "static/media/MoneyPack.db25dae2.svg";